import { ONLINE_ORDERING_ENABLED } from "../utils/constants";

/**
 * ComingSoonBadge — temporary, non-interactive "online ordering coming soon"
 * notice (SPR-014 T-007).
 *
 * Online ordering/checkout is disabled at launch (cart/checkout removed in
 * T-003). This presentational badge stands in where the "Add to Cart"
 * affordance used to be. It is purely informational — no cart/checkout logic.
 *
 * Gated entirely on `ONLINE_ORDERING_ENABLED`: when SPR-013 re-enables online
 * ordering, flip that flag to `true` (badge renders nothing) or delete this
 * component and its usages. Single, greppable removal point.
 *
 * @param {{ className?: string }} props
 */
export default function ComingSoonBadge({ className = "" }) {
  if (ONLINE_ORDERING_ENABLED) return null;

  return (
    <span
      data-testid="coming-soon-badge"
      role="status"
      className={[
        "inline-flex items-center gap-2 bg-mustard text-charcoal",
        "font-heading tracking-widest text-sm px-4 py-2 rounded-full",
        "border-2 border-charcoal shadow-[2px_2px_0_rgba(43,39,36,0.2)]",
        "select-none",
        className,
      ].join(" ")}
    >
      <span aria-hidden="true">🛒</span>
      Online ordering — coming soon!
    </span>
  );
}
